import { Table } from "antd";
import "./SubmissionResults.scss";

const SimpleObjRender = ({ obj }) => {
  return (
    <pre style={{ fontSize: "80%" }}>
      {Object.keys(obj).map((key) => (
        <span key={key}>
          {`${key} = `}
          <span
            style={{
              color: "blue",
              fontFamily: 'source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace',
            }}
          >{`${obj[key]}\n`}</span>
        </span>
      ))}
    </pre>
  );
};

export const SubmissionResults = ({ results }) => {
  if (!results) {
    return null;
  }

  const dataSource = JSON.parse(results).map((item, idx) => ({ ...item, key: idx }));
  const columns = [
    {
      dataIndex: "configuration",
      key: "configuration",
      render: (value) => <SimpleObjRender obj={value} />,
    },
    {
      dataIndex: "metrics",
      key: "metrics",
      render: (value) => <SimpleObjRender obj={value} />,
    },
  ];
  return (
    <Table
      style={{ width: 0, paddingLeft: 50 }}
      size="small"
      dataSource={dataSource}
      columns={columns}
      pagination={false}
      showHeader={false}
    />
  );
};
